import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { ISearchFacets } from "@shared/lib/types/briefInfluencerV2";

export function useGetBriefInfluencerSearchFacetsWithoutBriefId(
  statuses: string[]
) {
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<ISearchFacets>
  >({
    queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", statuses],
    queryFn: () =>
      BriefService.getBriefInfluencerSearchFacetsWithoutBriefId(statuses),
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    searchFacets: data?.data,
    isFetching: isLoading,
  };
}
